import React, { useEffect, useState } from 'react';
import ConfirmOrder from './confirmOrder';
import {
  collection,
  query,
  where,
  onSnapshot,
  orderBy,
} from 'firebase/firestore';
import moment from 'moment';
import db from '../../context/firestore';
import { Row, Col, Alert, InputGroup, Form, Button } from 'react-bootstrap';
import Order from './Order';
import Loading from '../Loading/Loading';

const SPA_FIREBASE_URL = process.env.REACT_APP_SPA_FIREBASE_URL;
const Orders = () => {
  const [newOrders, setNewOrders] = useState([]);
  const [conOrders, setConOrders] = useState([]);
  const [showOnlyParked, setShowOnlyParked] = useState(false);
  const [loading, setLoading] = useState(false);
  let date = moment(new Date()).format('YYYY-MM-DD');
  const [tillDate, setTillDate] = useState('');
  const [appliedTillDate, setAppliedTillDate] = useState('');
  // New Orders
  const getNewOrders = (tillDate) => {
    var q = query(
      collection(db, SPA_FIREBASE_URL),
      where('status', '==', 's'),
      orderBy('datetime_submitted', 'desc')
    );
    if (tillDate !== '') {
      q = query(
        collection(db, SPA_FIREBASE_URL),
        where('status', '==', 's'),
        where('booking_date', '==', tillDate),
        orderBy('datetime_submitted', 'desc')
      );
    }

    return onSnapshot(q, (querySnapshot) => {
      const orderOBJ = [];
      querySnapshot.forEach((doc) => {
        orderOBJ.push({ ...doc.data(), id: doc.id });
      });
      setNewOrders(orderOBJ);
      setLoading(false);
      console.log('Current orderOBJ: ', orderOBJ);
    });
  };

  // Confirm Orders
  const getConOrders = (tillDate) => {
    var q = query(
      collection(db, SPA_FIREBASE_URL),
      where('status', '==', 'a'),
      orderBy('datetime_approved', 'desc')
    );
    if (tillDate !== '') {
      q = query(
        collection(db, SPA_FIREBASE_URL),
        where('status', '==', 'a'),
        where('booking_date', '==', tillDate),
        orderBy('datetime_approved', 'desc')
      );
    }
    return onSnapshot(q, (querySnapshot) => {
      const orderOBJ = [];
      querySnapshot.forEach((doc) => {
        orderOBJ.push({ ...doc.data(), id: doc.id });
      });
      setConOrders(orderOBJ);
      setLoading(false);
      console.log('Current orderOBJ: ', orderOBJ);
    });
  };

  const getNextDate = () => {
    setAppliedTillDate(tillDate);
  };

  const resetDate = () => {
    setTillDate('');
    setAppliedTillDate('');
  };

  useEffect(() => {
    setLoading(true);
    const unsubscribeNewOrders = getNewOrders(appliedTillDate);
    const unsubscribeConOrders = getConOrders(appliedTillDate);

    return () => {
      unsubscribeNewOrders();
      unsubscribeConOrders();
    };
  }, [appliedTillDate]);

  const isParkedOrder = (order) =>
    order.is_parked === true || order.is_parked === 'true';

  const filteredNewOrders = showOnlyParked
    ? newOrders.filter((order) => isParkedOrder(order))
    : newOrders.filter((order) => !isParkedOrder(order));

  const filteredConOrders = showOnlyParked
    ? conOrders.filter((order) => isParkedOrder(order))
    : conOrders.filter((order) => !isParkedOrder(order));

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <Row className='mt-3'>
            <Col>
              <h6 className='heading heading-col'>Orders Schedule</h6>
            </Col>
            <Col className='mt-5' sm={12}>
              <Col
                sm={{ span: 4, offset: 2 }}
                className='mb-3 d-flex justify-content-start align-items-center'
              >
                <Form.Check
                  type='switch'
                  id='parked-toggle'
                  label='Show Parked Orders Only'
                  checked={showOnlyParked}
                  onChange={(e) => setShowOnlyParked(e.target.checked)}
                  className='form-switch-lg toggle-purple'
                />
              </Col>

              <Col sm={{ span: 8, offset: 2 }}>
                <InputGroup className='mb-3'>
                  <Form.Control
                    aria-label='Start Date'
                    type='date'
                    onChange={(e) => {
                      setTillDate(e.target.value);
                    }}
                    min={date}
                    name='tilldate'
                    value={tillDate}
                  />

                  <Button
                    className='mx-3'
                    variant='outline-dark'
                    id='getHistory'
                    onClick={getNextDate}
                  >
                    Check Schedule
                  </Button>
                  <Button
                    variant='outline-dark'
                    id='getHistory'
                    onClick={resetDate}
                  >
                    All Orders
                  </Button>
                </InputGroup>
              </Col>
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col>
              <h6 className='heading heading-col'>New Orders</h6>
            </Col>
            <Col>
              <h6 className='heading heading-col'>Confirmed Orders</h6>
            </Col>
          </Row>
          <Row style={{ height: '100vh' }}>
            <Col className='mt-2 column'>
              {filteredNewOrders.length === 0 ? (
                <Alert>No New Orders Found</Alert>
              ) : (
                ''
              )}
              {filteredNewOrders.map((order) => {
                return <Order order={order} key={order.id} />;
              })}
            </Col>

            <Col className='mt-2 column'>
              {filteredConOrders.length === 0 ? (
                <Alert>No Confirmed Orders Found</Alert>
              ) : (
                ''
              )}
              {filteredConOrders.map((order) => {
                return <ConfirmOrder order={order} key={order.id} />;
              })}
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default Orders;
